import type { SavedFlightItem } from "@/shared/api/aviabooking"
import { formatFlightWallTime } from "@/shared/lib/flight-wall-time"
import { Modal } from "@/shared/ui/modal"
import { useState } from "react"
import { FlightItinerary } from "../ticket/flight-itinerary"

interface Props {
    items: SavedFlightItem[]
    total: number
    nextOffset: number
    loading: boolean
    pending: string | null
    error: string
    failedOffset: number | null
    actionError: string
    onLoad: (offset: number) => Promise<void>
    onRemove: (item: SavedFlightItem) => Promise<void>
}

export function SavedFlights({ items, total, nextOffset, loading, pending, error, failedOffset, actionError, onLoad, onRemove }: Props) {
    const [selected, setSelected] = useState<SavedFlightItem | null>(null)
    return <section aria-label="Сохранённые рейсы" className="flex flex-col gap-4">
        <p className="text-sm text-slate-600">Сохранённые рейсы — исторические данные. Цена и наличие мест могут измениться. Для бронирования выполните новый поиск.</p>
        {error && <div role="alert">{error} <button type="button" onClick={() => void onLoad(failedOffset ?? 0)} className="underline">Повторить</button></div>}
        {actionError && <p role="alert">{actionError}</p>}
        {!loading && !error && items.length === 0 && <p>Сохранённых рейсов пока нет.</p>}
        {items.map(item => <article key={item.id} className="bg-white rounded-2xl p-5 shadow-sm flex flex-wrap gap-4 justify-between items-center">
            <div>
                <h3 className="font-bold">{item.snapshot.dep_airport_code} → {item.snapshot.arr_airport_code}</h3>
                <p>Вылет: {formatFlightWallTime(item.snapshot.segments[0]?.dep_date_time)}</p>
                <p>Цена на момент сохранения: {item.snapshot.price.amount} {item.snapshot.price.currency}</p>
                <p className="text-sm text-slate-500">Сохранено: {new Date(item.saved_at).toLocaleString("ru-RU")}</p>
            </div>
            <div className="flex gap-3">
                <button type="button" onClick={() => setSelected(item)} className="underline">Подробнее</button>
                <button type="button" disabled={pending !== null} onClick={() => void onRemove(item)} className="underline text-red-700">
                    {pending === item.offer_id ? "Удаление…" : "Удалить"}
                </button>
            </div>
        </article>)}
        {loading && <p role="status">Загрузка сохранённых рейсов…</p>}
        {nextOffset < total && !loading && !error && <button type="button" className="underline" onClick={() => void onLoad(nextOffset)}>Загрузить ещё</button>}
        <Modal isOpen={!!selected} title="Сохранённый рейс" onRequestClose={() => setSelected(null)}>
            {selected && <>
                <p className="mb-3">Исторические данные: рейс нельзя забронировать из сохранённого списка. Найдите актуальный рейс заново.</p>
                <FlightItinerary snapshot={selected.snapshot} />
            </>}
        </Modal>
    </section>
}
